import { render } from "./EditGym.vue?vue&type=template&id=ad42014a&scoped=true"
import script from "./EditGym.vue?vue&type=script&lang=js"
export * from "./EditGym.vue?vue&type=script&lang=js"

import "./EditGym.vue?vue&type=style&index=0&id=ad42014a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad42014a"]])

export default __exports__